const membersList = {
	
	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();
	},

	bindUI: function() {
		this.ui.$document = $(document);
		
		this.ui.$filter = $('.js-membersList-filter-category');

		this.ui.$searchInput = $('.js-membersList-search');

		this.ui.$listTitle = $('.js-membersList-title');

		this.ui.$tooltip = $('.js-svgMapRegion-tooltip');
		this.ui.$region = $('.js-svgMapRegion-region');
		
		this.ui.$memberCard = $('.js-memberCard');
		this.ui.$letterBlock = $('.js-memberList-letterBlock');

		this.ui.$mobileFilterToggle = $('.js-mobileFilter-toggle');
		this.ui.$mobileFilterContainer = $('.js-mobileFilter-container');
	},

	bindEvents: function() {
		this.ui.$region.on('mouseenter focus', this.showTooltip.bind(this));
		this.ui.$region.on('mouseleave blur', this.hideTooltip.bind(this));
		this.ui.$document.on('mousemove', this.trackTooltipPosition.bind(this));
		
		this.ui.$region.on('click', this.toggleRegion.bind(this));

		this.ui.$filter.on('click', this.filter.bind(this));

		this.ui.$mobileFilterToggle.on('click', this.toggleFilterBox.bind(this));

		this.ui.$searchInput.on('input', this.search.bind(this));
	},

	showTooltip: function(e) {
		let $this = $(e.currentTarget);
		
		this.ui.$tooltip.addClass('is-active');
		this.ui.$tooltip.html($this.attr('data-name'));
	},

	hideTooltip: function() {
		this.ui.$tooltip.removeClass('is-active');
	},

	updateCounterTitle: function() {
		const hasHiddenMember = $('.js-memberCard.--hidden').length > 0;
		const visibleMembers = $('.js-memberCard:not(.--hidden, .--search-hidden)').length;

		if (hasHiddenMember) {
			if (visibleMembers > 1) {
				this.ui.$listTitle.html(visibleMembers + ' membres associés');
			} else {
				this.ui.$listTitle.html(visibleMembers + ' membre associé');
			}
		} else {
			this.ui.$listTitle.html(visibleMembers + ' membres');
		}
	},

	trackTooltipPosition: function(e) {
		this.ui.$tooltip.css({
			left:  e.pageX,
			top:   e.pageY - 85
		});
	},
	
	toggleRegion: function(e) {
		let $this = $(e.currentTarget);
		
		if ($this.hasClass('is-active')) {
			$this.removeClass('is-active');
		} else {
			this.ui.$region.removeClass('is-active');
			$this.addClass('is-active');
		}

		this.resetSearch();
		this.filterMemberList();
	},

	toggleFilterBox: function() {
		if (this.ui.$mobileFilterContainer.hasClass('--active')) {
			this.ui.$mobileFilterContainer.removeClass('--active');
		} else {
			this.ui.$mobileFilterContainer.addClass('--active');
		}
	},
	
	filterMemberList: function(e) {
		const $activeRegion = $('.js-svgMapRegion-region.is-active');
		const $activeFilter = $('.js-membersList-filter-category.--active');
		const hasActiveRegion = $activeRegion.length > 0;
		const hasActiveFilter = $activeFilter.length > 0;

		if (!hasActiveRegion && !hasActiveFilter) {
			// Filter disabled so we show everything
			this.ui.$memberCard.removeClass('--hidden');
			this.updateCounterTitle();
			return false;
		}

		// Hide by default all member item
		this.ui.$memberCard.addClass('--hidden');

		let region, department, category = '';
		if (hasActiveRegion) {
			region = $activeRegion.attr('data-region');
			department = $activeRegion.attr('data-associated-department').split(',');
		}
		if (hasActiveFilter) {
			category = $activeFilter.attr('data-category');
		}

		// Crawl each member item and check if we display them
		this.ui.$memberCard.each((index, element) => {
			const $memberCard = $(element);
			const loc_type = $memberCard.attr('data-localisation-type');
			const matchRegion = this.regionMatch($memberCard, region);
			const matchDepartment = this.departmentMatch($memberCard, department);
			const matchCategory = this.categoryMatch($memberCard, category);

			if (hasActiveRegion && hasActiveFilter) {
				if (loc_type === 'all' && matchCategory) {
					$memberCard.removeClass('--hidden');
				} else if (loc_type === 'region') {
					if (matchRegion && matchCategory) {
						$memberCard.removeClass('--hidden');
					}
				} else if (loc_type === 'department') {
					if (matchDepartment && matchCategory) {
						$memberCard.removeClass('--hidden');
					}
				}
			} else if (hasActiveRegion && !hasActiveFilter) {
				if (loc_type === 'all') {
					$memberCard.removeClass('--hidden');
				} else if (loc_type === 'region') {
					if (matchRegion) {
						$memberCard.removeClass('--hidden');
					}
				} else if (loc_type === 'department') {
					if (matchDepartment) {
						$memberCard.removeClass('--hidden');
					}
				}
			} else if (!hasActiveRegion && hasActiveFilter) {
				if (matchCategory) {
					$memberCard.removeClass('--hidden');
				}
			}

		});

		this.updateCounterTitle();
	},

	regionMatch: function($memberCard, filter_region) {
		if (!filter_region) {
			return false;
		}
		const loc_region_attr = $memberCard.attr('data-localisation-region');
		if (!loc_region_attr) {
			return false;
		}
		const loc_region = loc_region_attr.split(',');
		return (loc_region.indexOf(filter_region) !== -1);
	},

	departmentMatch: function($memberCard, filter_department) {
		if (!filter_department) {
			return false;
		}
		const loc_department_attr = $memberCard.attr('data-localisation-department');
		if (!loc_department_attr) {
			return false;
		}
		const loc_department_list = loc_department_attr.split(',');
		let displayThisMember = false;
		loc_department_list.forEach((loc_department) => {
			if (filter_department.indexOf(loc_department) !== -1) {
				displayThisMember = true;
			}
		});
		return displayThisMember;
	},

	categoryMatch: function($memberCard, filter_category) {
		if (!filter_category) {
			return false;
		}
		const category = $memberCard.attr('data-category');
		return (category === filter_category);
	},

	filter: function(e) {
		let $this = $(e.currentTarget);

		if ($this.hasClass('--active')) {
			$this.removeClass('--active');
		} else {
			this.ui.$filter.removeClass('--active');
			$this.addClass('--active');
		}

		this.resetSearch();
		this.filterMemberList();
	},

	search: function(e) {
		let $this = $(e.currentTarget);

		const searchTerm = $this.val().toLowerCase().trim();
		const visibleMembers = $('.js-memberCard:not(.--hidden)');

		if (visibleMembers.length === 0) {
			return;
		}

		// Hide by default all member item
		this.ui.$memberCard.addClass('--search-hidden');

		visibleMembers.each((index, member) => {
			const $memberCard = $(member);
			const title = $memberCard.attr('data-title');
			if (!title) {
				return;
			}
			$memberCard.removeClass('--hidden');

			// Show card if search term is found in title or if search is empty
			if (searchTerm === '' || title.toLowerCase().includes(searchTerm)) {
				$memberCard.removeClass('--search-hidden');
			}
		});

		this.updateCounterTitle();
	},

	resetSearch: function() {
		this.ui.$searchInput.val('');
		this.ui.$memberCard.removeClass('--search-hidden');
	},
};

module.exports = membersList;